/** Projects as picker options, the signed-in person's own first.
 *
 * "Yours" means owned by you — the one link a project carries to a user record in the
 * list response. Everything else follows alphabetically. Each project appears once: a
 * duplicate further down would make the list longer, which is the thing being fixed.
 */

import type { SearchOption } from '@/components/SearchSelect'
import type { Project } from '@/lib/domain'

export function projectOptions(
  projects: Pick<Project, 'id' | 'name' | 'ownerUserId' | 'teamShortLabel'>[],
  userId: string | undefined,
): SearchOption[] {
  const byName = [...projects].sort((a, b) => a.name.localeCompare(b.name))
  const mine = userId ? byName.filter((project) => project.ownerUserId === userId) : []
  const rest = byName.filter((project) => !mine.includes(project))
  const toOption = (group: string | undefined) => (project: (typeof byName)[number]) => ({
    value: project.id,
    label: project.name,
    hint: project.teamShortLabel,
    group,
  })
  // No headings at all when there is nothing of yours: a lone "All projects" heading over
  // the whole list says nothing.
  if (mine.length === 0) return rest.map(toOption(undefined))
  return [...mine.map(toOption('Owned by you')), ...rest.map(toOption('All projects'))]
}
